<header class="header" [class.header--show-border-bottom]="isShowingActions()">
  <div class="header__wrapper">
    <div class="header__navigation">
      <odl-button
        id="header-go-back-button"
        [description]="'GO_BACK' | translate"
        (click)="goToPlatform()"
      >
        <odl-icon name="navigate_back" slot="only-icon" />
      </odl-button>
      <odl-tooltip for="#header-go-back-button">{{ 'GO_BACK' | translate }}</odl-tooltip>
      @if (isPreviewMode()) {
        <odl-tag variant="info">{{ 'PREVIEW' | translate }}</odl-tag>
      }
      @if (featureFlags.isEnabled('questions')()) {
        <nr-questions></nr-questions>
      }
    </div>
    <div class="header__title" [class.fade-out]="headerActionsClass().fadeOut">
      @if (resourceTitle()) {
        <h1 class="header__title-text" nrEllipsis>{{ resourceTitle() }}</h1>
      } @else {
        <nr-skeleton [type]="'resource-title'"></nr-skeleton>
      }
    </div>
    <div class="header__actions">
      <div
        class="header__actions-buttons"
        [class.fade-out]="headerActionsClass().fadeOut"
        [class.element-hidden]="headerActionsClass().elementHidden"
      >
        <odl-button
          [description]="'HEADER.CONTENTS_AND_BOOKMARKS' | translate"
          id="header-navigation-button"
        >
          <odl-icon name="list" slot="only-icon" />
        </odl-button>
        <odl-tooltip for="#header-navigation-button">
          {{ 'HEADER.CONTENTS_AND_BOOKMARKS' | translate }}
        </odl-tooltip>
        <odl-popover
          #navigationPopover
          class="header__actions-navigation-popover"
          [attr.for]="'#header-navigation-button'"
          placement="bottom-end"
        >
          <nr-navigation-tabs (nrNavigated)="navigationPopover.open = false"></nr-navigation-tabs>
        </odl-popover>
        <odl-button id="reader-config" [description]="'HEADER.STYLE_SETTINGS' | translate">
          <odl-icon name="font" slot="only-icon" />
        </odl-button>
        <odl-tooltip for="#reader-config">{{ 'HEADER.STYLE_SETTINGS' | translate }}</odl-tooltip>
        <odl-popover
          class="reader-settings-wrapper"
          [attr.for]="'#reader-config'"
          placement="bottom-end"
        >
          <nr-reader-settings-tabs></nr-reader-settings-tabs>
        </odl-popover>
        @if (featureFlags.isEnabled('finder')()) {
          <odl-button id="header-search-button" [description]="'SEARCH' | translate">
            <odl-icon name="search" slot="only-icon" />
          </odl-button>
          <odl-tooltip for="#header-search-button">{{ 'SEARCH' | translate }}</odl-tooltip>
        }

        @if (featureFlags.hasAnyMoreOption()) {
          <odl-button
            id="header-more-options-button"
            [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
          >
            <odl-icon name="more_vert" slot="only-icon" />
          </odl-button>
          <odl-tooltip for="#header-more-options-button">
            {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}</odl-tooltip
          >
        } @else {
          <odl-button
            id="header-fullscreen-button"
            [description]="
              (fullscreenService.isFullscreen() ? 'EXIT_FULLSCREEN' : 'FULLSCREEN') | translate
            "
            (click)="fullscreenService.toggle()"
          >
            <odl-icon
              [name]="fullscreenService.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'"
              slot="only-icon"
            />
          </odl-button>
          <odl-tooltip for="#header-fullscreen-button">
            {{ (fullscreenService.isFullscreen() ? 'EXIT_FULLSCREEN' : 'FULLSCREEN') | translate }}
          </odl-tooltip>
        }
      </div>
      @if (featureFlags.isEnabled('bookmarks')()) {
        <odl-button
          id="header-bookmark-button"
          class="header__bookmark"
          [description]="
            (activeBookmark() ? 'HEADER.DELETE_BOOKMARK' : 'HEADER.ADD_BOOKMARK') | translate
          "
          (click)="toggleBookmark()"
          [class.fade-out]="bookmarkClass().fadeOut"
          [class.element-hidden]="bookmarkClass().elementHidden"
        >
          <odl-icon [name]="activeBookmark() ? 'bookmark_black' : 'bookmark'" slot="only-icon" />
        </odl-button>
        <odl-tooltip for="#header-bookmark-button">
          {{ (activeBookmark() ? 'HEADER.DELETE_BOOKMARK' : 'HEADER.ADD_BOOKMARK') | translate }}
        </odl-tooltip>
      }
    </div>
  </div>
</header>
